import React, {createContext, FunctionComponent, PropsWithChildren, useContext} from 'react';

interface OrgCatalogState {
    fetching: boolean;
}

interface OrgCatalogAction {
    type: OrgCatalogStateActions;
    state?: Partial<OrgCatalogState>;
}

enum OrgCatalogStateActions {
    SET_FETCHING = 'SET_FETCHING',
}

type OrgCatalogDispatcher = (action: OrgCatalogAction) => void;

export const setFetching = (isFetching: boolean) => ({
    type: OrgCatalogStateActions.SET_FETCHING,
    state: {
        fetching: isFetching,
    },
});

export const DEFAULT_ORG_CATALOG_STATE = {
    fetching: false,
};

export const orgCatalogReducer = (previousState: OrgCatalogState, action: OrgCatalogAction) => {
    const {state, type} = action;

    switch (type) {
        case OrgCatalogStateActions.SET_FETCHING:
            return {
                ...previousState,
                ...state,
            };

        default:
            return previousState;
    }
};

const OrgCatalogContext = createContext<OrgCatalogState>(DEFAULT_ORG_CATALOG_STATE);
const OrgCatalogContextDispatch = createContext<OrgCatalogDispatcher | undefined>(undefined);

type OrgCatalogProviderProps = {
    catalogGlobalState: OrgCatalogState;
    catalogGlobalDispatch: OrgCatalogDispatcher;
};

export const OrgCatalogContextProvider: FunctionComponent<
    PropsWithChildren<OrgCatalogProviderProps>
> = (props) => {
    const {catalogGlobalState, catalogGlobalDispatch, children} = props;

    return (
        <OrgCatalogContext.Provider value={catalogGlobalState}>
            <OrgCatalogContextDispatch.Provider value={catalogGlobalDispatch}>
                {children}
            </OrgCatalogContextDispatch.Provider>
        </OrgCatalogContext.Provider>
    );
};

export const useOrgCatalogState = () => {
    const context = useContext(OrgCatalogContext);
    if (context === undefined) {
        throw new Error('make sure to use OrgCatalogContext within the OrgCatalogContextProvider');
    }

    return context;
};

export const useOrgCatalogDispatcher = () => {
    const context = useContext(OrgCatalogContextDispatch);
    if (context === undefined) {
        throw new Error(
            'make sure to use OrgCatalogContextDispatch within the OrgCatalogContextProvider'
        );
    }

    return context;
};
